module.exports = __webpack_public_path__ + "img/weichi.b38f32df.png";